export default __webpack_public_path__ + "static/media/phone_dashboard.6336db33.png";